import { render, staticRenderFns } from "./TakeIn.vue?vue&type=template&id=588ea600"
import script from "./TakeIn.vue?vue&type=script&lang=js"
export * from "./TakeIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports